
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import { useContext, useEffect, useState } from 'react';
import './entreprise.css';
import { wilayas, communes } from '../../data.js';
import { useParams, useNavigate } from 'react-router-dom';
import { addEntreprise, getEntreprises, ToggleActiveEntreprise, updateEntreprise } from '../../context/entrepriseContext/apiCalls.js';
import ErrorComponent from '../../components/errorComponent/ErrorComponent.jsx';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent.jsx';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent.jsx';
import FilterInput from '../../components/filterInput/FilterInput.jsx';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent.jsx';
import TableComponent from '../../components/tableComponent/TableComponent.jsx';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent.jsx';
import { EntrepriseContext } from '../../context/entrepriseContext/EntrepriseContext.js';
import ModalComponent from '../../components/modalComponent/ModalComponent.jsx';
import SubLoadingComponent from '../../components/subLoadingComponent/SubLoadingComponent.jsx';
import FormInput from '../../components/formInput/FormInput.jsx';

function Entreprise() {
    const { entreprises, dispatch, isFetching, error, entreprise, isFetchingAdd, errorAdd, isFetchingUpdate, errorUpdate, count: pages, isFetchingActivate} = useContext(EntrepriseContext);
    const [wilaya, setWilaya] = useState(wilayas[0]);
    const [commune, setCommune] = useState(communes[0][0]);
    const [nom, setNom] = useState("");
    const [email, setEmail] = useState("");

    const { page = 1 } = useParams();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);
    const listItems = [10, 20, 30, 40, 50, 100];

    useEffect(() => {
        getEntreprises(dispatch, pageSize, page, wilaya.id, commune.id, nom, email);
    }, [dispatch, page, pageSize, wilaya, commune, nom, email])

    useEffect(() => {
        setCommune(communes[wilaya.id][0]);
    }, [wilaya])

    useEffect(() => {
        navigate(`/entreprises/1`);
    }, [wilaya, commune, nom, email])

    useEffect(() => {
        getEntreprises(dispatch, pageSize, page, wilaya.id, commune.id, nom, email);
    }, [entreprise])

    const toggleActive = (entrepriseId) => {
        ToggleActiveEntreprise(dispatch, entrepriseId);
    }

    // console.log('entreprises', entreprises);


    /**************  Ajouter Modal  **************/
    const [modalAddActive, setModalAddActive] = useState(false);
    const [addNom, setAddNom] = useState("");
    const [addEmail, setAddEmail] = useState("");
    const [addAddress, setAddAddress] = useState("");
    const [addCostPromotion, setAddCostPromotion] = useState("0");
    const [addRamassagePromotion, setAddRamassagePromotion] = useState("0");
    const [addDepotPromotion, setAddDepotPromotion] = useState("0");
    const [addTel1, setAddTel1] = useState("");
    const [addTel2, setAddTel2] = useState("");
    const [addErrorBox, setAddErrorBox] = useState("");
    const [addWilaya, setAddWilaya] = useState(wilayas[0]);
    const [addCommune, setAddCommune] = useState(communes[0][0]);
    const [addRc, setAddRc] = useState("");
    const [addNif, setAddNif] = useState("");
    const [addNis, setAddNis] = useState("");
    const [addAi, setAddAi] = useState("");

    useEffect(() => {
        setAddCommune(communes[addWilaya.id][0]);
    }, [addWilaya])

    const handleAddEntreprise = () => {
        if (addNom.trim() == "") {
            setAddErrorBox('Vous devez compléter le Nom');
            return;
        }
        if (addWilaya.id === 0) {
            setAddErrorBox('Vous devez compléter la Wilaya');
            return;
        }
        if (addCommune.id === 0) {
            setAddErrorBox('Vous devez compléter la Commune');
            return;
        }
        if (addAddress.trim() == "") {
            setAddErrorBox("Vous devez compléter l'Adresse");
            return;
        }
        if (addEmail.trim() == "") {
            setAddErrorBox('Vous devez compléter le Email');
            return;
        }
        if (addTel1.trim() == "") {
            setAddErrorBox('Vous devez compléter le Numero de Tel');
            return;
        }
        if (addCostPromotion.trim() == "") {
            setAddErrorBox('Vous devez compléter le Cout Promotion');
            return;
        }
        if (addCostPromotion < 0 || addCostPromotion > 1) {
            setAddErrorBox('Vous devez mettre un numero entre 0 et 1');
            return;
        }
        if (addRamassagePromotion.trim() == "") {
            setAddErrorBox('Vous devez compléter le Ramassage Promotion');
            return;
        }
        if (addRamassagePromotion < 0 || addRamassagePromotion > 1) {
            setAddErrorBox('Vous devez mettre un numero entre 0 et 1');
            return;
        }
        if (addDepotPromotion.trim() == "") {
            setAddErrorBox('Vous devez compléter le Depot Promotion');
            return;
        }
        if (addDepotPromotion < 0 || addDepotPromotion > 1) {
            setAddErrorBox('Vous devez mettre un numero entre 0 et 1');
            return;
        }

        // if (addRc.trim() == "") {
        //     setAddErrorBox('Vous devez compléter le numero de registre commerce');
        //     return;
        // }
        // if (addNif.trim() == "") {
        //     setAddErrorBox("Vous devez compléter le numero d'identification fiscale");
        //     return;
        // }
        // if (addNis.trim() == "") {
        //     setAddErrorBox("Vous devez compléter le numero d'identification statistique");
        //     return;
        // }
        // if (addAi.trim() == "") {
        //     setAddErrorBox("Vous devez compléter l'article d'imposition");
        //     return;
        // }

        addEntreprise(dispatch, addNom, addWilaya.id, addCommune.id, addTel1, addTel2, addEmail, addAddress, addCostPromotion, addRamassagePromotion, addDepotPromotion, addRc, addNif, addNis, addAi);
        setAddNom('');
        setAddWilaya(wilayas[0]);
        setAddCommune(communes[0][0]);
        setAddTel1('');
        setAddTel2('');
        setAddEmail('');
        setAddAddress('');
        setAddCostPromotion('0');
        setAddRamassagePromotion('0');
        setAddDepotPromotion('0');
        setAddRc(''); setAddNif(''); setAddNis(''); setAddAi('');
        setModalAddActive(false);
        setAddErrorBox('');
    }

    /**************  End Ajouter Modal  **************/

    /**************  Update Modal  **************/
    const [modalUpdateActive, setModalUpdateActive] = useState(false);
    const [updateId, setUpdateId] = useState("");
    const [updateNom, setUpdateNom] = useState("");
    const [updateEmail, setUpdateEmail] = useState("");
    const [updateAddress, setUpdateAddress] = useState("");
    const [updateCostPromotion, setUpdateCostPromotion] = useState("0");
    const [updateRamassagePromotion, setUpdateRamassagePromotion] = useState("0");
    const [updateDepotPromotion, setUpdateDepotPromotion] = useState("0");
    const [updateTel1, setUpdateTel1] = useState("");
    const [updateTel2, setUpdateTel2] = useState("");
    const [updateErrorBox, setUpdateErrorBox] = useState("");
    const [updateWilaya, setUpdateWilaya] = useState(wilayas[0]);
    const [updateCommune, setUpdateCommune] = useState(communes[0][0]);
    const [updateRc, setUpdateRc] = useState("");
    const [updateNif, setUpdateNif] = useState("");
    const [updateNis, setUpdateNis] = useState("");
    const [updateAi, setUpdateAi] = useState("");

    const updateModalUpdateActive = (id, nom, wilayaa, communee, email, tel1, tel2, address, costPromotion, ramassagePromotion, depotPromotion, rc, nif, nis, ai) => {
        setModalUpdateActive(true);
        setUpdateId(id);
        setUpdateNom(nom);
        setUpdateWilaya(wilayas.filter(item => item.id == wilayaa)[0]);
        setUpdateCommune(communes[wilayaa].filter(item => item.id == communee)[0]);
        setUpdateEmail(email);
        setUpdateTel1(tel1);
        setUpdateTel2(tel2 || "");
        setUpdateAddress(address || "");
        setUpdateCostPromotion(costPromotion || '0');
        setUpdateRamassagePromotion(ramassagePromotion || '0');
        setUpdateDepotPromotion(depotPromotion || '0');
        setUpdateRc(rc);
        setUpdateNif(nif);
        setUpdateNis(nis);
        setUpdateAi(ai);
    }

    const handleUpdateEntreprise = () => {
        if (updateNom.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Nom');
            return;
        }
        if (updateWilaya.id === 0) {
            setUpdateErrorBox('Vous devez compléter la Wilaya');
            return;
        }
        if (updateCommune.id === 0) {
            setUpdateErrorBox('Vous devez compléter la Commune');
            return;
        }
        if (updateAddress.trim() == "") {
            setUpdateErrorBox("Vous devez compléter l'Adresse");
            return;
        }
        if (updateEmail.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Email');
            return;
        }
        if (updateTel1.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Tel1');
            return;
        }
        if (updateCostPromotion.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Cout Promotion');
            return;
        }
        if (updateCostPromotion < 0 || updateCostPromotion > 1) {
            setUpdateErrorBox('Vous devez mettre un numero entre 0 et 1');
            return;
        }
        if (updateRamassagePromotion.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Ramassage Promotion');
            return;
        }
        if (updateRamassagePromotion < 0 || updateRamassagePromotion > 1) {
            setUpdateErrorBox('Vous devez mettre un numero entre 0 et 1');
            return;
        }
        if (updateDepotPromotion.trim() == "") {
            setUpdateErrorBox('Vous devez compléter le Depot Promotion');
            return;
        }
        if (updateDepotPromotion < 0 || updateDepotPromotion > 1) {
            setUpdateErrorBox('Vous devez mettre un numero entre 0 et 1');
            return;
        }
        // if (updateRc.trim() == "") {
        //     setUpdateErrorBox('Vous devez compléter le numero de registre commerce');
        //     return;
        // }
        // if (updateNif.trim() == "") {
        //     setUpdateErrorBox("Vous devez compléter le numero d'identification fiscale");
        //     return;
        // }
        // if (updateNis.trim() == "") {
        //     setUpdateErrorBox("Vous devez compléter le numero d'identification statistique");
        //     return;
        // }
        // if (updateAi.trim() == "") {
        //     setUpdateErrorBox("Vous devez compléter l'article d'imposition");
        //     return;
        // }

        updateEntreprise(dispatch, updateId, updateNom, updateWilaya.id, updateCommune.id, updateEmail, updateTel1, updateTel2, updateAddress, updateCostPromotion, updateRamassagePromotion, updateDepotPromotion, updateRc, updateNif, updateNis, updateAi);
        setUpdateId('')
        setUpdateNom('');
        setUpdateWilaya(wilayas[0]);
        setUpdateCommune(communes[0][0]);
        setUpdateEmail('');
        setUpdateAddress('');
        setUpdateTel1('');
        setUpdateTel2('');
        setUpdateCostPromotion('0');
        setUpdateRamassagePromotion('0');
        setUpdateDepotPromotion('0');
        setUpdateRc(''); setUpdateNif(''); setUpdateNis(''); setUpdateAi('');
        setModalUpdateActive(false);
        setUpdateErrorBox('');
    }

    /**************  End Update Modal  **************/


    return (
        <div className='container-global'>
            <AdminSideBar activeTab="entreprise" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Entreprises</span>
                </div>

                {
                    error ? <ErrorComponent error={error} /> : (
                        <>
                            <div className="filter">
                                <span className="adv-research">Recherche Avancée</span>
                                <div className="filter-content">
                                    <DropDownComponent data={wilayas} itemChoisir={wilaya} setItemChoisir={setWilaya} filter />
                                    <DropDownComponent data={communes[wilaya.id]} itemChoisir={commune} setItemChoisir={setCommune} filter />
                                    <FilterInput placeholder={"Nom"} setItem={setNom} />
                                    <FilterInput placeholder={"Email"} setItem={setEmail} />
                                </div>
                            </div>

                            <div className="add-item">
                                <span className='color-1' onClick={() => setModalAddActive(true)}>Ajouter</span>
                            </div>

                            {
                                isFetching ? <LoadingComponent /> : (
                                    entreprises.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                                        : (
                                            <>
                                                <PageSizeComponent listItems={listItems} pageSize={pageSize} setPageSize={setPageSize} itemLocation='entreprises' />
                                                <div className="content">
                                                    {
                                                        <>
                                                            <TableComponent headers={['Id', 'Nom', 'Wilaya', 'Commune', 'Cout Promo', 'Ram Promo', 'Depot Promo', 'Date', 'Action']}>
                                                                {
                                                                    entreprises.map((entreprise, index) => (
                                                                        <tr key={index}>
                                                                            <td>{entreprise.id}</td>
                                                                            <td>{entreprise.nom}</td>
                                                                            <td>{wilayas.filter(item => item.id == entreprise.wilaya)[0]['nom']}</td>
                                                                            <td>{communes[entreprise.wilaya].filter(item => item.id == entreprise.commune)[0]['nom']}</td>
                                                                            <td>{entreprise.costPromotion}</td>
                                                                            <td>{entreprise.ramassagePromotion}</td>
                                                                            <td>{entreprise.depotPromotion}</td>
                                                                            <td>{entreprise.createdAt.slice(0, 10)}</td>
                                                                            <td>
                                                                                <span className='update' onClick={() => updateModalUpdateActive(entreprise.id, entreprise.nom, entreprise.wilaya, entreprise.commune, entreprise.email, entreprise.tel1, entreprise.tel2, entreprise.address, entreprise.costPromotion, entreprise.ramassagePromotion, entreprise.depotPromotion, entreprise.rc, entreprise.nif, entreprise.nis, entreprise.ai)}>Modifier</span>
                                                                                <span className='detail' onClick={() => toggleActive(entreprise.id)} style={isFetchingActivate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                                                                    {
                                                                                        isFetchingActivate ? (
                                                                                            entreprise.active == 0 ? "Activer..." : "Disactiver..."
                                                                                        ) : (
                                                                                            entreprise.active == 0 ? "Activer" : "Disactiver"
                                                                                        )
                                                                                    }
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </TableComponent>
                                                            {
                                                                (pages > 1) && (<PaginationComponent page={page} pages={pages} item='entreprises' />)
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </>
                                        )
                                )
                            }
                        </>
                    )
                }
            </div>

            {/*  Modal Components */}
            {
                <>
                    <ModalComponent modalActive={modalAddActive} setModalActive={setModalAddActive} setErrorBox={setAddErrorBox} title="Ajouter Entreprise">
                        {
                            errorAdd ? setAddErrorBox(errorAdd) : (
                                isFetchingAdd ? <SubLoadingComponent /> : (
                                    <form>
                                        {addErrorBox !== "" && (<div className='box-error'>{addErrorBox}</div>)}
                                        <FormInput label='Nom *' itemInput={addNom} setItemInput={setAddNom} auth />
                                        <div className='side-to-side'>
                                            <DropDownComponent data={wilayas} itemChoisir={addWilaya} setItemChoisir={setAddWilaya} />
                                            <DropDownComponent data={communes[addWilaya.id]} itemChoisir={addCommune} setItemChoisir={setAddCommune} />
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label='Adresse *' itemInput={addAddress} setItemInput={setAddAddress} auth />
                                            <FormInput label='Email *' itemInput={addEmail} setItemInput={setAddEmail} auth />
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label='Tel1 *' itemInput={addTel1} setItemInput={setAddTel1} istype='number' auth />
                                            <FormInput label='Tel2' itemInput={addTel2} setItemInput={setAddTel2} istype='number' auth />
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label='Cout Promo *' itemInput={addCostPromotion} setItemInput={setAddCostPromotion} istype='number' auth />
                                            <FormInput label='Ram Promo *' itemInput={addRamassagePromotion} setItemInput={setAddRamassagePromotion} istype='number' auth />
                                            <FormInput label='Depot Promo *' itemInput={addDepotPromotion} setItemInput={setAddDepotPromotion} istype='number' auth />
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label='RC N°' itemInput={addRc} setItemInput={setAddRc} auth />
                                            <FormInput label='NIF N°' itemInput={addNif} setItemInput={setAddNif} auth />
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label='NIS N°' itemInput={addNis} setItemInput={setAddNis} auth />
                                            <FormInput label='AI N°' itemInput={addAi} setItemInput={setAddAi} auth />
                                        </div>
                                        <div className='button' onClick={handleAddEntreprise}>
                                            <span>Valider</span>
                                        </div>
                                    </form>
                                )
                            )
                        }
                    </ModalComponent>

                    <ModalComponent modalActive={modalUpdateActive} setModalActive={setModalUpdateActive} setErrorBox={setUpdateErrorBox} title="Update Agence">
                        {
                            errorUpdate ? setUpdateErrorBox(errorUpdate) : (
                                isFetchingUpdate ? <SubLoadingComponent /> : (
                                    <form>
                                        {updateErrorBox !== "" && (<div className='box-error'>{updateErrorBox}</div>)}
                                        <FormInput label='Nom *' itemInput={updateNom} setItemInput={setUpdateNom} auth />
                                        <div className='side-to-side'>
                                            <DropDownComponent data={wilayas} itemChoisir={updateWilaya} setItemChoisir={setUpdateWilaya} />
                                            <DropDownComponent data={communes[updateWilaya.id]} itemChoisir={updateCommune} setItemChoisir={setUpdateCommune} />
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label='Adresse *' itemInput={updateAddress} setItemInput={setUpdateAddress} auth />
                                            <FormInput label='Email *' itemInput={updateEmail} setItemInput={setUpdateEmail} auth />
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label='Tel1 *' itemInput={updateTel1} setItemInput={setUpdateTel1} auth />
                                            <FormInput label='Tel2' itemInput={updateTel2} setItemInput={setUpdateTel2} auth />
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label='Cout Promo *' itemInput={updateCostPromotion} setItemInput={setUpdateCostPromotion} istype='number' auth />
                                            <FormInput label='Ramassage Promo *' itemInput={updateRamassagePromotion} setItemInput={setUpdateRamassagePromotion} istype='number' auth />
                                            <FormInput label='Depot Promo *' itemInput={updateDepotPromotion} setItemInput={setUpdateDepotPromotion} istype='number' auth />
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label='RC N°' itemInput={updateRc} setItemInput={setUpdateRc} auth />
                                            <FormInput label='NIF N°' itemInput={updateNif} setItemInput={setUpdateNif} auth />
                                        </div>
                                        <div className='side-to-side'>
                                            <FormInput label='NIS N°' itemInput={updateNis} setItemInput={setUpdateNis} auth />
                                            <FormInput label='AI N°' itemInput={updateAi} setItemInput={setUpdateAi} auth />
                                        </div>
                                        <div className='button' onClick={handleUpdateEntreprise}>
                                            <span>Valider</span>
                                        </div>
                                    </form>
                                )
                            )
                        }
                    </ModalComponent>
                </>
            }
            {/*  End Modal Components */}
        </div>
    )
}
export default Entreprise;